const BaseComponent = require('common/home-block/extend');

class cpaListComp extends BaseComponent {
  init () {
    super.init();
  }
}
module.exports = cpaListComp;
